"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testUser = void 0;
exports.testUser = {
    identifier: 1,
    name: 'John Doe',
    email: 'john.doe@3d4medical.com',
    avatar: 'https://cdn.3d4medical.com/complete_anatomy-userdata/11938/groups/20170713_150903.jpeg',
    kind: 'Student',
    biography: 'My biography',
    institution: 'Test',
    specialties: [
        {
            identifier: 0,
            name: 'Emergency Medicine',
        },
    ],
    hasActiveUpgradeOrSubscription: false,
};
